import { Brain } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const AICoFounderStrip = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="container max-w-5xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <Brain className="h-8 w-8 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Not just AI — your freelance co-founder.
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
            Most AI tools just answer prompts. Catlyo's AI reads your pipeline, invoices, tasks, clients, and goals. 
            Every day, it writes a clear banner explaining how your business is trending, suggests one high-leverage move 
            to focus on, and estimates the impact if you act. It also explains why each item is in your Super Queue — 
            in plain, human language.
          </p>
        </div>

        {/* Example AI Message Card */}
        <Card className="border-primary/20 bg-card/50 backdrop-blur">
          <CardContent className="p-6">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <Brain className="h-5 w-5 text-primary" />
                </div>
                <div className="space-y-2 flex-1">
                  <p className="text-base font-medium">
                    Hey there 👋, your business is trending positively.
                  </p>
                  <p className="text-sm text-muted-foreground">
                    84% task completion and ₹72K collected this month — you're on track to hit your revenue goal (forecast: growth).
                  </p>
                  <div className="mt-4 p-4 bg-primary/5 rounded-lg border border-primary/10">
                    <p className="text-sm font-medium mb-2">💡 Next Best Action:</p>
                    <p className="text-sm text-muted-foreground">
                      Follow up with your top 2 negotiation-stage deals today — that could add ~₹30K to this month's revenue.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default AICoFounderStrip;
